import { Controller } from "@hotwired/stimulus"

// Shows only the credential fields relevant to the selected auth type on the
// external data source form. Each field wrapper carries data-auth with a
// space-separated list of auth types it applies to.
export default class extends Controller {
  static targets = ["select", "field"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.selectTarget.value
    this.fieldTargets.forEach((field) => {
      const applies = (field.dataset.auth || "").split(" ").includes(selected)
      field.classList.toggle("hidden", !applies)
    })
  }
}
